import { setSelectedEmailId } from '../State/selectedEmailId';
import { setShowViewEmailModal } from '../State/showViewEmailModal';

export default (emailId) => async (dispatch) => {

  dispatch(setSelectedEmailId(emailId));
  dispatch(setShowViewEmailModal(true));

}